// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Graficos_PegagraficoorigensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Graficos_PegagraficoorigensResponseDados {
origens: string[]
valor_orcamentos: number[]
}

export type Graficos_PegagraficoorigensResponse = ApiResponse<Graficos_PegagraficoorigensResponseDados>;

registerResponseContract('Graficos_PegagraficoorigensResponse', {
  origens:          { type: 'array',   required: true },
  valor_orcamentos: { type: 'array',   required: true },
})
